import { useEffect, useState, useRef } from "react";
import { LocationMarker } from "../../../../models/Pharse2/LocationMap";
import {
	MapContainer,
	TileLayer,
	useMap,
	Marker,
	Popup,
	Tooltip,
	Polygon
} from 'react-leaflet'
import './leaflet.css'
import { LatLngExpression, LatLngTuple } from "leaflet";
interface Prop {
	locationMarkerList: LocationMarker[]
	handleMarkersClick: (id: number, id1: number) => void
}

export default function NewMap({ locationMarkerList, handleMarkersClick }: Prop) {

	const [satelliteOpt, setSatelliteOpt] = useState<{ satellite: any, map: any }>();
	const [satelliteMode, setSatelliteMode] = useState(true);
	const [init,setInit] = useState<boolean>(true);
	const [zone, setZone] = useState<number[][] | undefined>(undefined);
	const L = require("leaflet");
	const isFirstRender = useRef(true);
	const findInitialCenter = (markers: LocationMarker[]) => {
		if (markers.length === 0) {
			return [22.31163421362307, 113.91598196464943]
		}
		let i = 1
		for (let marker of markers) {
			if (marker.latitude === undefined || marker.longtitude === undefined) continue
			if (marker.latitude > 5 && marker.longtitude > 5 && i !== markers.length) {
				return [marker.latitude, marker.longtitude]
			}
			if (i === markers.length) {
				return [marker.latitude, marker.longtitude]
			}
			i++;
		}
		return [22.31163421362307, 113.91598196464943];
	}
	useEffect(() => {


		delete L.Icon.Default.prototype._getIconUrl;

		L.Icon.Default.mergeOptions({
			iconRetinaUrl: require("./images/marker-icon-2x.png"),
			iconUrl: require("./images/marker-icon.png"),
			shadowUrl: require("./images/marker-shadow.png")
		});
	}, []);
	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		setInit(true);
	}, [locationMarkerList]);
	function ChangeView({ center }: { center: number[] }) {
		const map = useMap();
		map.setView(center as LatLngExpression, 13);
		setInit(false);
		return null;
	}
	return (
		<MapContainer scrollWheelZoom={true} style={{ width: "100%", height: "800px" }}>
			{init && <ChangeView center={findInitialCenter(locationMarkerList)} />}
			<TileLayer
				   url='https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
				   maxZoom= {20}
				   subdomains={['mt1','mt2','mt3']}
			/>
			<TileLayer
				   url='https://mapapi.geodata.gov.hk/gs/api/v1.0.0/xyz/label/hk/tc/wgs84/{z}/{x}/{y}.png'
				   maxZoom= {20}
				   subdomains={['mt1','mt2','mt3']}
			/>
			{locationMarkerList.map((i) => {
				return (
					<Marker position={[i.latitude, i.longtitude]} key={i.locationId} icon={L.icon({ iconUrl: '/assets/markers/' + i.url, iconSize: [50, 42], iconAnchor: [25, 41] })} eventHandlers={{
						click: (e) => {
							handleMarkersClick(i.locationId, i.projectId)
						},
						mouseover: (e) => {
							setZone([
								[22.314022267258764,113.94080616705064,],
								[22.313793218491483, 113.94205091449861],
								[22.313292267919532, 113.941567176368],
								[22.313459251643245, 113.94080185932556]
							  ])
						},
						mouseout: (e) => {
							setZone(undefined);
						}
					}} >
						<Tooltip>
							{i.name}
						</Tooltip>
					</Marker>
				)
			})}
			{zone !== undefined && <Polygon pathOptions={{color:'black'}} positions={zone as any} />}
		</MapContainer>
	)
}